import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { useAppSelector, RootState } from './redux/store';
import { ldFeatureFlags } from './utils/LDFeatureFlagsUtils';

function InitLD() {
  const ldFlags = useFlags();
  const ldClient = useLDClient()!;
  const authContext = useAppSelector((state: RootState) => state.auth.authContext);

  useEffect(() => {
    ldFeatureFlags.setFlags(ldFlags)
  }, [ldFlags]);

  useEffect(() => {
    if (authContext && authContext.email && ldClient) {
      ldClient.identify({ 
        key: authContext.userId,
        email: authContext.email, 
        companyId: authContext.companyId, 
        userId: authContext.userId
      });
    }
  }, [ldClient, authContext]);
  return <></>;
}
export default InitLD;
